import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Helmet from 'react-helmet';
import { Button, FormControl, FormGroup, HelpBlock } from 'react-bootstrap';
import { Field, reduxForm, SubmissionError } from 'redux-form';
import Joi from 'joi';
import Fa from 'react-fontawesome';

// Import Selectors
import { getUserCurrentOrganization } from '../../../Auth/AuthReducer';
import { requestUpdateOrganization } from '../../../Admin/AdminActions';

class LeaderboardPage extends Component {
  constructor() {
    super();
    this.state = {
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.renderField = this.renderField.bind(this);
  }

  componentDidMount() {
    const { organization } = this.props;
    const data = {
      naughty_list_threshold: organization.naughty_list_threshold || 50,
    };
    this.props.initialize(data);
  }


  handleSubmit(data) {
    const { organization } = this.props;
    data.naughty_list_threshold = parseFloat(data.naughty_list_threshold);
    return this.props.dispatch(requestUpdateOrganization(organization._id, data))
      .then(
        () => {},
        (errors) => {
          throw new SubmissionError(errors.data || errors);
        },
      );
  }
  
  renderField({
    input, label, type, meta: { touched, error },
  }) {
    const { submitting } = this.props;
    const validationState = touched && error ? 'error' : null;
    return (
      <FormGroup validationState={validationState}>
        <FormControl {...input} placeholder={label} type={type} disabled={submitting} />
        <FormControl.Feedback />
        {touched && error && <HelpBlock>{error}</HelpBlock>}
      </FormGroup>
    );
  }

  render() {
    const { handleSubmit, submitting, valid } = this.props;
    return (
      <div>
        <Helmet title="Leaderboard | Organization Setup" />
        <div className="container">
          <form onSubmit={handleSubmit(this.handleSubmit)}>
            <div className="panel panel-default">
              <div className="panel-heading">
              Naughty List Percent Threshold
              </div>
              <div className="panel-body">
                <div>Sales reps that have a percent lower than the set threshold will show up on the Naughty List</div>
                <FormGroup>
                  <Field name="naughty_list_threshold" type="text" component={this.renderField} label="Threshold percentage" />
                </FormGroup>
              </div>
              <div className="panel-footer text-right">
                <Button bsStyle="primary" type="submit" disabled={submitting || !valid}><Fa name={submitting ? 'spinner' : 'edit'} /> Update</Button>
              </div>
            </div>
          </form>
        </div>
      </div>
    );
  }
}


// Retrieve data from store as props
function mapStateToProps(state) {
  return {
    organization: getUserCurrentOrganization(state),
  };
}

LeaderboardPage.propTypes = {
  organization: PropTypes.shape({
    naughty_list_threshold: PropTypes.number,
  }).isRequired,
  submitting: PropTypes.bool,
  handleSubmit: PropTypes.func,
  initialize: PropTypes.func,
  valid: PropTypes.bool,
  dispatch: PropTypes.func.isRequired,
};

LeaderboardPage.defaultProps = {
  submitting: false,
  valid: false,
  handleSubmit: () => {},
  initialize: () => {},
};

const validate = (values) => {
  // Legacy constraints for reference:
  // const constraints = {
  //   naughty_list_threshold: { numericality: { strict: true, greaterThanOrEqualTo: 0, lessThanOrEqualTo: 100 }, presence: true },
  // };

  const schema = Joi.object({
    naughty_list_threshold: Joi.number().min(0).max(100).required().messages({
      'number.base': 'Threshold must be a number',
      'number.min': 'Threshold must be at least 0',
      'number.max': 'Threshold must be at most 100',
      'any.required': 'Threshold is required',
    }),
  }).unknown(true);

  const { error } = schema.validate(values, { abortEarly: false });
  if (!error) return {};
  
  return error.details.reduce((acc, curr) => {
    if (!acc[curr.path[0]]) acc[curr.path[0]] = [];
    acc[curr.path[0]].push(curr.message);
    return acc;
  }, {});
};

const LeaderboardPageForm = reduxForm({
  form: 'leaderboardSetupForm',
  validate,
})(LeaderboardPage);

export default connect(mapStateToProps)(LeaderboardPageForm);